import { Heading } from "@chakra-ui/react";

export default function H2({ children, ...rest }) {
  return (
    <Heading
      as="h2"
      fontWeight="bold"
      fontSize="2rem"
      lineHeight="1.2"
      letterSpacing="0.3px"
      {...rest}
    >
      {children}
    </Heading>
  );
}
